import { render } from "./measures.vue?vue&type=template&id=b2057846"
import script from "./measures.vue?vue&type=script&lang=js"
export * from "./measures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__